/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type Gender = typeof Gender[keyof typeof Gender];


export const Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  DIVERSE: 'DIVERSE',
  NOT_SPECIFIED: 'NOT_SPECIFIED',
} as const;
